import { activeQuestion, updateActiveQuestion } from "../../stores";
import QuestionCell from "./QuestionCell";
import { NUM_QUESTIONS } from "../../stores";
import { createSignal, createEffect, onMount, For } from "solid-js";
import { interview, userAnswers, setUserAnswers } from "../../stores/userStore";
import { fetchFeedback } from "../../services/interviewActions/interviewService";
import Loading from "../Loading";

export default function QuestionJail({ setNum, focusQuestion }) {
  // Create a ref to the container
  let questionJailRef;
  const [loading, setLoading] = createSignal(false);

  function changeQuestionNum(num) {
    setNum(num);
  }

  onMount(async () => {
    setLoading(true);
    console.log(`On mount answers: ${userAnswers()}`);
    // If answers are not in store, fetch from DB

    if (interview().status === 1) {
      setUserAnswers(Array(NUM_QUESTIONS).fill(null));
    } else {
      const storedFeedback = await fetchFeedback(interview().feedback_id);
      setUserAnswers(storedFeedback.answers);
      console.log(`Set user answers to ${userAnswers()}`);
    }
    setLoading(false);
  });

  // Create an effect that responds to activeQuestion changes
  createEffect(() => {
    const activeIndex = focusQuestion();

    if (activeIndex >= 0 && questionJailRef) {
      // Get all cells
      const cells = questionJailRef.querySelectorAll(".question-cell");
      if (cells[activeIndex]) {
        // Get the container's scrollable width
        const scrollWidth = questionJailRef.scrollWidth;
        const containerWidth = questionJailRef.clientWidth;

        // Get the cell we want to center
        const activeCell = cells[activeIndex];
        const cellWidth = activeCell.offsetWidth;

        // Calculate the center position of the cell
        const cellOffsetLeft = activeCell.offsetLeft;
        const cellCenter = cellOffsetLeft + cellWidth / 2;

        // Calculate the ideal scroll position (centered)
        let idealScrollLeft = cellCenter - containerWidth / 2;

        // Constrain the scroll position between 0 and max scroll
        const maxScroll = scrollWidth - containerWidth;
        const boundedScrollLeft = Math.max(
          0,
          Math.min(idealScrollLeft, maxScroll),
        );

        // Smooth scroll to the position
        questionJailRef.scrollTo({
          left: boundedScrollLeft,
          behavior: "smooth",
        });
      }
    }
  });

  return (
    <div id="question-jail" ref={questionJailRef}>
      <For each={Array.from({ length: NUM_QUESTIONS }, (_, i) => i)}>
        {(i) => (
          <QuestionCell
            key={i}
            theme={interview().themes[i]}
            answered={() => userAnswers() && userAnswers()[i] !== null}
            onClick={() => {
              changeQuestionNum(i);
            }}
            focusQuestion={focusQuestion}
          />
        )}
      </For>
      <Loading show={loading()} />
    </div>
  );
}
